module.exports = __webpack_public_path__ + "img/poly-1.fa75bee6.png";